@if ({}; as STATE) {
  <section class="brand-creation-dialog">
    <brand-creation-form [brand]="brand()" />
  </section>
}
